import React from "react";

/**
 * SectionHeader — the heading strip that sits at the top of a card, above a
 * table or a form. Title (with optional icon + count badge) is pinned left,
 * the toolbar (filters, refresh, export, add…) is pinned right, and the
 * filter row drops onto its own full-width line below instead of pushing the
 * title around when it opens.
 *
 * Props
 *  - title    : section title (required)
 *  - icon     : react-icons element shown before the title
 *  - count    : optional badge next to the title
 *  - subtitle : optional one-liner under the title
 *  - actions  : nodes pinned to the right of the title row
 *  - filters  : nodes rendered in the collapsible row underneath
 *  - filtersOpen : whether the filter row is shown
 */
const SectionHeader = ({
  title,
  icon,
  count,
  subtitle,
  actions,
  filters,
  filtersOpen = false,
}) => (
  <div className="section-header">
    <div className="section-header__row">
      <div className="section-header__title-wrap">
        {icon ? (
          <span className="section-header__icon" aria-hidden="true">
            {icon}
          </span>
        ) : null}
        <div>
          <h2 className="section-header__title">
            {title}
            {count !== undefined && count !== null ? (
              <span className="section-header__count">{count}</span>
            ) : null}
          </h2>
          {subtitle ? (
            <p className="section-header__subtitle">{subtitle}</p>
          ) : null}
        </div>
      </div>

      {actions ? <div className="section-header__actions">{actions}</div> : null}
    </div>

    {filters && filtersOpen ? (
      <div className="section-header__filters">{filters}</div>
    ) : null}
  </div>
);

export default SectionHeader;
